import { Accordion, AccordionSummary, AccordionDetails, AccordionWrapper } from '../Accordion/';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Typography from '@mui/material/Typography';
import marked from 'marked';
import React from 'react';
import { cgtag } from 'utilities/gtag';

export interface FAQType {
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  title?: string;
  items: FAQType[];
}

const FAQAccordion: React.FC<FAQAccordionProps> = ({ items, title }) => {
  return (
    <AccordionWrapper items={items} title={title}>
      {(Item: any, index: number, expanded: boolean, onChange: (event: React.SyntheticEvent<Element, Event>, isExpanded: boolean) => void) => (
        <Accordion
          key={`faq${index}`}
          elevation={0}
          expanded={expanded}
          onChange={(ev) => {
            if (!expanded) {
              cgtag('faq', {
                question: Item.question,
                answer: Item.answer,
              });
            }
            onChange(ev, !expanded);
          }}
          disableGutters
        >
          <AccordionSummary expandIcon={expanded ? <RemoveIcon /> : <AddIcon />} aria-label="Expand" aria-controls={`panel${index}-faq-content`} id={`panel${index}-faq-header`} sx={{ pr: 0 }}>
            {Item.question}
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              component="div"
              variant="body1"
              dangerouslySetInnerHTML={{
                __html: marked(Item.answer),
              }}
            />
          </AccordionDetails>
        </Accordion>
      )}
    </AccordionWrapper>
  );
};

export default FAQAccordion;
